import type { CloudGraphCalendarEventEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI: CloudGraphCalendarEventEntityAti[] = [
	'ati:cloud:graph:calendar-event',
];
